import React, { useEffect, useState } from "react"
import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import InfoPopup from "components/InfoPopup"
import {
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
} from "reactstrap"
import { fetchUserDetails } from "../../../redux/actions/user"
import "../../../assets/view-user.css"

const PVS_STATUS_CONFIG = {
  pending:       { color: "info",    label: "Draft" },
  paid:          { color: "info",    label: "In Review" },
  clarification: { color: "warning", label: "Action Required" },
  approved:      { color: "success", label: "Verified" },
  rejected:      { color: "danger",  label: "Rejected" },
}

function getPvsStatusConfig(status) {
  return PVS_STATUS_CONFIG[status] || { color: "secondary", label: status || "Unknown" }
}

const ViewUser = () => {
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewFile, setPreviewFile] = useState(null)

  const [openAccordion, setOpenAccordion] = useState("0")

  const toggleAccordion = id => {
    setOpenAccordion(openAccordion === id ? "" : id)
  }

  const openPreview = (path, label) => {
    setPreviewFile({
      url: path,
      name: label,
      type: "image/jpeg",
    })
    setPreviewOpen(true)
  }

  const closePreview = () => {
    setPreviewOpen(false)
    setPreviewFile(null)
  }

  const { enc_id, type } = useParams()
  let enc_user_id = ""
  let enc_pvs_entry_id = ""
  if (type == "user") {
    enc_user_id = enc_id
  } else if (type == "pvs") {
    enc_pvs_entry_id = enc_id
  }
  const history = useNavigate()
  const dispatch = useDispatch()

  const userState = useSelector(state => state.user)

  const [userData, setUserData] = useState()

  const handleDownload = (url, filename) => {
    fetch(url, { mode: "cors" }) // Fetch the file
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement("a")
        link.href = window.URL.createObjectURL(blob)
        link.download = filename // Set desired filename
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
      .catch(err => console.error("Download failed:", err))
  }

  useEffect(() => {
    let payload = {}
    if (enc_user_id) {
      payload = { enc_user_id }
    } else {
      payload = { enc_pvs_entry_id }
    }
    dispatch(fetchUserDetails(payload))
  }, [dispatch, enc_user_id, enc_pvs_entry_id])

  useEffect(() => {
    if (userState && userState.user) {
      setUserData(userState.user)
    }
  }, [userState])


  const [activeTab, setActiveTab] = useState("profile")

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  const getIconForActivityType = type => {
    switch (type) {
      case "pvs": return "mdi mdi-card-account-details"
      case "profile": return "mdi mdi-account-circle"
      case "event":
      case "past-event": return "mdi mdi-calendar-check"
      case "award":
      case "competition": return "mdi mdi-trophy"
      case "bazaar": return "mdi mdi-cart"
      case "lucky-draw": return "mdi mdi-gift"
      case "network-meet": return "mdi mdi-handshake"
      default: return "mdi mdi-information"
    }
  }

  const getTypeColor = type => {
    switch (type) {
      case "profile": return "welcome-color"
      case "pvs":
      case "pvs card number": return "pvs-color"
      case "lucky-draw":
      case "network-meet":
      case "award":
      case "competition":
      case "bazaar":
      case "past-event": return "event-color"
      case "cancelled": return "danger"
      default: return "secondary"
    }
  }

  const formatActivityDate = dateString => {
    const date = new Date(dateString)
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    })
  }

  const getActivityTitle = (data, firstName) => {
    if (data.type === "profile") {
      return `Hi ${firstName}, Congratulations! On starting your journey with PULA`
    } else if (data.type === "pvs") {
      return `You Received PVS Card #${data.pvs_card_number}`
    } else if (
      data.type === "lucky-draw" ||
      data.type === "network-meet" ||
      data.type === "award" ||
      data.type === "competition" ||
      data.type === "bazaar" ||
      data.type === "past-event"
    ) {
      return `Participated In ${data.event_name}`
    }
    return data.event_name || ""
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="mb-4"></div>

          <Nav tabs className="pula-profile-tabs mb-4">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "profile" })}
                onClick={() => toggleTab("profile")}
              >
                <i className="mdi mdi-account-circle me-1"></i>
                Profile Details
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "activity" })}
                onClick={() => toggleTab("activity")}
              >
                <i className="mdi mdi-history me-1"></i>
                User Activity
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab} className="pula-tab-content">
            <TabPane
              tabId="profile"
              className={`pula-tab-pane ${
                activeTab === "profile" ? "active" : ""
              }`}
            >
              {/* Basic Details */}
              {userData && userData.user?.user_id && (
                <Card className="pula-profile-card">
                  <CardBody className="pula-card-body">
                    <div className="pula-card-header mb-4">
                      <div className="pula-card-title">
                        <i className="mdi mdi-account"></i>
                        <span>Basic Details</span>
                      </div>
                    </div>
                    <Row className="align-items-center">
                      <Col md={3} className="text-center">
                        {userData && userData.user.user_profile_url ? (
                          <img
                            src={userData.user.user_profile_url}
                            alt="User"
                            className="pula-profile-avatar border-primary"
                          />
                        ) : (
                          <div className="pula-profile-avatar d-flex align-items-center justify-content-center border-primary">
                           <i className="mdi mdi-account"></i>
                          </div>
                        )}
                      </Col>
                      <Col md={9}>
                        <Row>
                          {[
                            {
                              label: "Name",
                              value:
                                `${userData?.user.first_name || ""} ${
                                  userData?.user.last_name || ""
                                }`.trim() || "-",
                            },
                            {
                              label: "Email Id",
                              value: userData?.user.email_id,
                            },
                            {
                              label: "Mobile No",
                              value: userData?.user.mobile_no,
                            },
                            {
                              label: "User Type",
                              value: userData?.user.user_type,
                            },
                            {
                              label: "Registered Source",
                              value: userData?.user.registration_source,
                            },
                            {
                              label: "Created At",
                              value: userData?.user.created_modified_at,
                            },
                          ].map((item, index) => (
                            <Col md={6} key={index}>
                              <div className="pula-info-row">
                                <span className="label">{item.label}</span>
                                <span className="colon">:</span>
                                <span className="value">
                                  {item.value || "-"}
                                </span>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              )}

              {userData?.pvs_cards?.length > 0 ? (
                <Accordion open={openAccordion} toggle={toggleAccordion}>
                  {userData.pvs_cards.map((pvs, index) => (
                    <AccordionItem key={index}>
                      <AccordionHeader targetId={String(index)} style={{ color: getPvsStatusConfig(pvs.status).color }}>
                        <i className="mdi mdi-store me-2"></i>
                        {`PVS details for ${pvs.brand_name || "—"}`}
                        <span className={`badge bg-${getPvsStatusConfig(pvs.status).color} ms-2`}>
                          {getPvsStatusConfig(pvs.status).label}
                        </span>
                      </AccordionHeader>

                      <AccordionBody accordionId={String(index)}>
                        <Row className="gy-4 pula-info-card">
                          {/* LEFT COLUMN */}
                          <Col md={6}>
                            {[
                              { label: "Seller Name", value: pvs.seller_name },
                              { label: "Mobile", value: pvs.seller_contact_no },
                              { label: "Keywords", value: pvs.keywords_label },
                              {
                                label: "Permanent Address",
                                value: pvs.permanent_address,
                              },
                              {
                                label: "Facebook Link",
                                value: pvs.social_fb_link,
                                isLink: true,
                              },
                            ].map((item, i) => (
                              <div className="pula-info-row" key={i}>
                                <span className="label">{item.label}</span>
                                <span className="colon">:</span>
                                {item.isLink && item.value ? (
                                  <a
                                    href={item.value}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="value"
                                  >
                                    {item.value}
                                  </a>
                                ) : (
                                  <span className="value">
                                    {item.value || "-"}
                                  </span>
                                )}
                              </div>
                            ))}
                          </Col>

                          {/* RIGHT COLUMN */}
                          <Col md={6}>
                            {[
                              { label: "Account ID", value: pvs.account_id },
                              { label: "Email", value: pvs.seller_email_id },
                              { label: "Brand Name", value: pvs.brand_name },
                              {
                                label: "Interest",
                                value: pvs.categories_label,
                              },
                              { label: "Address", value: pvs.address },
                              // {
                              //   label: "Status",
                              //   value: (
                              //     <span className="pula-status-badge">
                              //       {pvs.status_label}
                              //     </span>
                              //   ),
                              // },
                              {
                                label: "Approval Message",
                                value: pvs.approval_status,
                              },
                            ].map((item, i) => (
                              <div className="pula-info-row" key={i}>
                                <span className="label">{item.label}</span>
                                <span className="colon">:</span>
                                <span className="value">
                                  {item.value || "-"}
                                </span>
                              </div>
                            ))}
                          </Col>
                        </Row>

                        {/* ================= PVS CARD DETAILS ================= */}
                        <Row className="pula-card-info align-items-center">
                          <div className="pula-card-header">
                            <div className="pula-card-title">
                              <i
                                className="ion ion-ios-albums text-success me-2"
                                style={{ fontSize: "20px" }}
                              ></i>
                              PVS Card Details
                            </div>
                          </div>
                          <Col md={12} className="mb-4">
                            {[
                              {
                                label: "Brand Name",
                                value: pvs?.brand_name,
                              },
                              {
                                label: "Card Number",
                                value: pvs.token_code,
                              },
                              {
                                label: "Pay Id",
                                value: pvs.pay_id,
                              },
                              {
                                label: "Paid Amount",
                                value: (
                                  <span>
                                    {" "}
                                    ₹ {pvs.amount || "-"}
                                  </span>
                                ),
                              },
                              ...(pvs.status === "approved"
                                ? [
                                    {
                                      label: "Download Card",
                                      value: (
                                        <span>
                                          <a
                                            href="#"
                                            onClick={e => {
                                              e.preventDefault()
                                              handleDownload(
                                                pvs.pvs_card_link,
                                                `${pvs.token_code}.jpg`
                                              )
                                            }}
                                            className="btn-primary"
                                          >
                                            Download
                                          </a>
                                        </span>
                                      ),
                                    },
                                  ]
                                : []),
                            ].map((item, index) => (
                              <div key={index} className="mb-2 d-flex">
                                <strong style={{ width: "150px" }}>
                                  {item.label}
                                </strong>
                                <span style={{ width: "30px" }}>:</span>
                                <span>{item.value || "-"}</span>
                              </div>
                            ))}
                          </Col>
                          {/* <Col md={12} className="pvsdet-img-col">
                            <img
                              src={
                                pvs.pvs_card_link ||
                                "/default-card.png"
                              }
                              alt="PVS Card"
                              className="img-thumbnail img-fluid mb-2"
                              style={{ maxHeight: "120px" }}
                            />
                          </Col> */}
                        </Row>

                        {/* ================= PVS DOCUMENTS (LIST / TABLE) ================= */}
                        <Card className="pula-profile-card">
                          <div className="pula-card-header">
                            <div className="pula-card-title">
                              <i className="ion ion-ios-document"></i>
                              <span>PVS Documents</span>
                            </div>
                          </div>

                          <CardBody className="p-0">
                            {pvs &&
                            [
                              pvs.aadhar_card_img_path,
                              pvs.aadhar_card_img_back_path,
                              pvs.permanent_address_img_path,
                              pvs.pune_address_img_path,
                              pvs.brand_logo_path,
                              pvs.seller_photo_path,
                            ].some(Boolean) ? (
                              <table className="pula-doc-table">
                                <thead>
                                  <tr>
                                    <th>Document</th>
                                    <th className="text-center">Preview</th>
                                    <th className="text-center">Download</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {[
                                    {
                                      label: "Aadhar Card Front",
                                      path: pvs.aadhar_card_img_path,
                                    },
                                    {
                                      label: "Aadhar Card Back",
                                      path: pvs.aadhar_card_img_back_path,
                                    },
                                    {
                                      label: "Permanent Address",
                                      path: pvs.permanent_address_img_path,
                                    },
                                    {
                                      label: "Pune Address",
                                      path: pvs.pune_address_img_path,
                                    },
                                    {
                                      label: "Brand Logo",
                                      path: pvs.brand_logo_path,
                                    },
                                    {
                                      label: "Seller Photo",
                                      path: pvs.seller_photo_path,
                                    },
                                  ]
                                    .filter(doc => doc.path)
                                    .map((doc, index) => (
                                      <tr key={index}>
                                        <td>{doc.label}</td>

                                        <td className="text-center">
                                          <button
                                            className="pula-icon-btn"
                                            onClick={() =>
                                              openPreview(doc.path, doc.label)
                                            }
                                          >
                                            <i className="ion ion-md-eye"></i>
                                          </button>
                                        </td>

                                        <td className="text-center">
                                          <button
                                            className="pula-icon-btn"
                                            onClick={() =>
                                              handleDownload(
                                                doc.path,
                                                `${doc.label.replace(
                                                  /\s+/g,
                                                  "_"
                                                )}.jpg`
                                              )
                                            }
                                          >
                                            <i className="ion ion-md-download"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            ) : (
                              <div className="pula-no-data">
                                No Documents Found
                              </div>
                            )}
                          </CardBody>
                        </Card>
                      </AccordionBody>
                    </AccordionItem>
                  ))}
                </Accordion>
              ) : (
                <div className="pula-no-data text-center">
                  No PVS Details Found
                </div>
              )}

              {/* {userData?.pvs_cards?.length > 0 && (
                <>
                  <Card>
                    <CardBody></CardBody>
                  </Card>
                </>
              )} */}
            </TabPane>

            {/* User Activity */}
            <TabPane
              tabId="activity"
              className={`pula-tab-pane ${
                activeTab === "activity" ? "active" : ""
              }`}
            >
              {userData && (
                <>
                  <h4 className="font-size-18 mb-3 nom-title">{`${userData.user?.first_name}'s Timeline`}</h4>
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="vu-timeline">
                      {(() => {
                        const activityList = [...(userData?.all_activity_list || [])]
                        if (userData?.user) {
                          activityList.push({
                            event_name: `Hi ${userData.user.first_name}, Congratulations! On starting your journey with PULA`,
                            created_date: userData.user.created_modified_at,
                            status: "Completed",
                            type: "profile",
                          })
                        }
                        return activityList.map((activity, index) => (
                          <div
                            key={activity.id || index}
                            className={`vu-timeline-item ${
                              index % 2 === 0 ? "vu-timeline-item--left" : "vu-timeline-item--right"
                            }`}
                          >
                            {index < activityList.length - 1 && (
                              <div className="vu-timeline-line"></div>
                            )}
                            {activityList.length === 1 && (
                              <div className="vu-timeline-line" style={{ height: "20%" }}></div>
                            )}
                            <div className={`vu-timeline-dot ${getTypeColor(activity.type)}`}>
                              <i className={`${getIconForActivityType(activity.type)} vu-timeline-icon`}></i>
                            </div>
                            <div className={`vu-timeline-content ${getTypeColor(activity.type)}`}>
                              <div
                                className={`d-flex flex-column mt-1 ${
                                  index % 2 === 0 ? "align-items-end" : "align-items-start"
                                }`}
                              >
                                <h5 className="font-size-16 mt-1 mb-1">
                                  {getActivityTitle(activity, userData.user?.first_name)}
                                </h5>
                                <div className="d-flex align-items-center gap-2 mb-2">
                                  <small className="text-white">
                                    <i className="bx bx-calendar me-1"></i>
                                    {formatActivityDate(activity.created_date)}
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      })()}
                    </div>
                  </div>
                  <style jsx>{`
                    .vu-timeline {
                      position: relative;
                      padding: 10px 0;
                      width: 70%;
                    }

                    .vu-timeline-item {
                      position: relative;
                      display: flex;
                      min-height: 80px;
                      margin-top: 24px;
                      align-items: flex-end;
                    }

                    .vu-timeline-line {
                      position: absolute;
                      left: 50%;
                      top: 20px;
                      width: 2px;
                      height: calc(100% + 60px);
                      background-color: #e9ecef;
                      transform: translateX(-50%);
                    }

                    .welcome-color {
                      background: linear-gradient(135deg, #ff69b4, #b86cff);
                    }

                    .pvs-color {
                      background: linear-gradient(135deg, #1fbf75, #0f9d58);
                    }

                    .event-color {
                      background: linear-gradient(135deg, #4facfe, #00c6ff);
                    }

                    .vu-timeline-dot {
                      position: absolute;
                      left: 50%;
                      top: 50px;
                      width: 25px;
                      height: 25px;
                      border-radius: 50%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      z-index: 1;
                      transform: translateX(-50%);
                    }

                    .vu-timeline-icon {
                      font-size: 12px;
                      color: #fff;
                    }

                    .vu-timeline-content {
                      width: calc(50% - 20px);
                      padding: 10px 24px;
                      box-sizing: border-box;
                      border-radius: 10px;
                      margin-top: 50px;
                      color: #fff;
                      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
                    }

                    .vu-timeline-item--left {
                      justify-content: flex-start;
                    }

                    .vu-timeline-item--left .vu-timeline-content {
                      text-align: right;
                      padding-right: 20px;
                      margin-right: 20px;
                      max-width: calc(50% - 20px);
                    }

                    .vu-timeline-item--right {
                      justify-content: flex-end;
                    }

                    .vu-timeline-item--right .vu-timeline-content {
                      padding-left: 20px;
                      margin-left: 20px;
                      max-width: calc(50% - 20px);
                    }

                    @media (max-width: 672px) {
                      .vu-timeline {
                        padding: 0 16px;
                        width: 100%;
                      }

                      .vu-timeline-line {
                        left: 12px;
                        transform: none;
                      }

                      .vu-timeline-dot {
                        left: 12px;
                        transform: translateX(-50%);
                      }

                      .vu-timeline-item--left,
                      .vu-timeline-item--right {
                        justify-content: flex-start;
                      }

                      .vu-timeline-item--left .vu-timeline-content,
                      .vu-timeline-item--right .vu-timeline-content {
                        text-align: left;
                        width: calc(100% - 36px);
                        margin-left: 36px;
                        padding-left: 16px;
                        padding-right: 16px;
                        margin-right: 0;
                        max-width: 100%;
                        margin-top: 40px;
                      }
                    }
                  `}</style>
                </>
              )}
            </TabPane>
          </TabContent>
        </Container>
      </div>
      <InfoPopup
        isOpen={previewOpen}
        toggle={closePreview}
        title="Document Preview"
        previewFile={previewFile}
        btnClass="btn-primary"
      />
    </React.Fragment>
  )
}

export default ViewUser
